'use strict';
const mmWidgets = require('./mm-widgets'),
	stripeConfig = require('@mindmup/mindmup-config/src/stripe-plans');

require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');

mmWidgets.fn.addInsWidget = function (subscriptionAddInsModel) {
	if (!subscriptionAddInsModel) {
		throw new Error('invalid-args');
	}

	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget(),
			addInTemplate = element.find('[data-mm-role~="add-in-template"]').detach().removeAttr('data-mm-role'),
			addInContainer = element.find('[data-mm-role~="add-in-container"]'),
			showAddIn = (addIn) => {
				const addInItem = addInTemplate.clone(),
					priceSelector = addInItem.find('[data-mm-role~="price-selector"]'),
					removeButton = addInItem.find('[data-mm-role~=remove]'),
					upgradeButton = addInItem.find('[data-mm-role~=upgrade]'),
					dateActivated = addIn.created && new Date(addIn.created * 1000),
					unit = addIn.unitName || 'users',
					// amount = Number.parseFloat(addIn.amountInCents / 100).toFixed(2),
					planCurrency = stripeConfig.currencies[addIn.currency.toUpperCase()],
					addTierToSelector = (tier, isActive) => {
						const description = `${tier.quantity} ${unit} @ ${planCurrency.prefix}${tier.price}${planCurrency.postfix} per ${addIn.period}`,
							option = mmWidgets('<option>').text(description);
						if(isActive) {
							option.val('');
						} else {
							option.val(tier.quantity);
						}
						priceSelector.append(option);
					},
					getStatusDescription = () => {
						if (addIn.status === 'cancelled') {
							const exp = new Date(addIn.expiry * 1000);
							return `- cancelled, expires on ${exp.toLocaleDateString()}`;
						}
						if (addIn.status === 'active') {
							return `- active for ${addIn?.currentTier.quantity} ${unit}`;
						}
						return '';
					},
					priceSelectorChanged = () => {
						const val = priceSelector.val();
						if (val) {
							removeButton.addClass('hidden');
							upgradeButton.removeClass('hidden');
						} else {
							removeButton.removeClass('hidden');
							upgradeButton.addClass('hidden');
						}
					};
				addInItem.find('[data-mm-role~="date-activated"]').text( (dateActivated && dateActivated.toLocaleDateString()) || '');
				if (addIn.currentTier) {
					addTierToSelector(addIn.currentTier, true);
				}
				addIn.quantities.forEach(tier => addTierToSelector(tier));
				priceSelectorChanged();
				// addInItem.find('[data-mm-role~="amount"]').text(amount);
				// addInItem.find('[data-mm-role~="currency"]').text(planCurrency.postfix);
				// addInItem.find('[data-mm-role~="symbol"]').text(planCurrency.prefix);
				// addInItem.find('[data-mm-role~="period"]').text(addIn.period);

				addInItem.find('[data-mm-role~="status"]').text(getStatusDescription());
				addInItem.find('[data-mm-role~="name"]').text(addIn.name);
				addInItem.find('[data-mm-role~="description"]').text(addIn.description);
				addInItem.find('[data-mm-role~="add-in-link"]').attr('href', addIn.link);
				addInItem.find('[data-mm-required-action]').addClass('hidden');
				addIn.allowedActions.forEach(action => addInItem.find(`[data-mm-required-action~=${action}]`).removeClass('hidden'));

				addInItem.find('[data-mm-role~=activate]').click(() => subscriptionAddInsModel.requestPreview(addIn.id, parseInt(priceSelector.val())));
				upgradeButton.click(() => subscriptionAddInsModel.requestPreview(addIn.id, parseInt(priceSelector.val())));

				removeButton.click(() => subscriptionAddInsModel.remove(addIn.id));
				addInItem.find('[data-mm-role~=restore]').click(() => subscriptionAddInsModel.restore(addIn.id));

				addInContainer.append(addInItem);
				addInContainer.removeClass('hidden');

				priceSelector.on('change', priceSelectorChanged);
			},
			timestampDescending = (r1, r2) => {
				return r2.timestamp - r1.timestamp;
			},
			showAddIns = (addIns) => {
				if (addIns && addIns.length) {
					addInContainer.empty();
					addIns.sort(timestampDescending).forEach(addIn => showAddIn(addIn));
					element.showSection('add-in-list');
				} else {
					element.showSection('empty-add-in-list');
				}
			};

		subscriptionAddInsModel.addEventListener('loadingAddIns', () => {
			element.showProgressMessage('Loading add ins, please wait...');
		});
		subscriptionAddInsModel.addEventListener('loadedAddIns', showAddIns);

		subscriptionAddInsModel.addEventListener('removalInProgress', () => {
			addInContainer.addClass('hidden');
			element.showProgressMessage('Cancelling the add in renewal, please wait...');
		});

		subscriptionAddInsModel.addEventListener('removalStatus restoreStatus', (newStatus) => {
			element.showSection(newStatus);
		});
		subscriptionAddInsModel.addEventListener('restoreInProgress', () => {
			addInContainer.addClass('hidden');
			element.showProgressMessage('Restoring the add in, please wait...');
		});
		subscriptionAddInsModel.addEventListener('error', reason => element.showError(reason));
	});

};
